export class WebhookV1ViolationsDetectionNotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "totalResources",
            "baseName": "totalResources",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "controlName",
            "baseName": "controlName",
            "type": "string",
            "format": ""
        },
        {
            "name": "detected",
            "baseName": "detected",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1ViolationsDetectionNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
